// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".online_doc_h3[data-v-2fbc179b]{color:#666;font-size:16px;line-height:32px;margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
